const initialState = {
  loading: false,
  data: [] as any[],
  error: null as any,
  roles: {
    loading: false,
    data: [] as any[],
    error: null as any,
  },
};

export default function userManagement(state = initialState, action: any) {
  switch (action.type) {
    case 'GET_USERS_LOADING':
      return { ...state, loading: true, error: null };
    case 'GET_USERS_SUCCESS': {
      const raw = action.payload || {};
      const mapped = (raw.data || []).map((u: any) => ({
        userName: u?.UserFullName || '',
        email: u?.UserEmail || '',
        role: u?.Role || '',
        status: u?.IsActive ? 'Active' : 'Inactive',
        lastLogin: u?.LastLogin || null,
        _raw: u,
      }));
      return { ...state, loading: false, data: mapped };
    }
    case 'GET_USERS_ERROR':
      return { ...state, loading: false, error: true };
    case 'CREATE_USER_LOADING':
    case 'UPDATE_USER_LOADING':
    case 'DELETE_USER_LOADING':
      return { ...state, loading: true, error: null };
    case 'CREATE_USER_SUCCESS':
    case 'UPDATE_USER_SUCCESS':
      return { ...state, loading: false };
    case 'DELETE_USER_SUCCESS': {
      const id = action.payload;
      const updated = (state.data || []).filter((row: any) => (row?._raw?.UserId || row?.UserId) !== id);
      return { ...state, loading: false, data: updated };
    }
    case 'CREATE_USER_ERROR':
    case 'UPDATE_USER_ERROR':
    case 'DELETE_USER_ERROR':
      return { ...state, loading: false, error: true };
    case 'GET_ROLES_LOADING':
      return { ...state, roles: { ...state.roles, loading: true, error: null } };
    case 'GET_ROLES_SUCCESS': {
      const payload = action.payload || {};
      const list = (payload?.data ?? payload) || [];
      const mapped = Array.isArray(list) ? list : [];
      return { ...state, roles: { loading: false, data: mapped, error: null } };
    }
    case 'GET_ROLES_ERROR':
      return { ...state, roles: { ...state.roles, loading: false, error: true } };
    default:
      return state;
  }
}
